module.exports = __webpack_public_path__ + "img/live-1.af0cc921.png";